export class AuthenticationCheckHook {

    static $inject = ["$transitions", 'IdentityService', "$location"];

    constructor($transitions, identity, $location) {

        $transitions.onBefore({
            to: function (state) {
                return state.data && state.data.requiresAuth;
            }
        }, function (transition) {
            if (identity.isAnonymous()) {
                return transition.router.stateService.target("sign-in", {redirectTo: $location.path()});
            }
        });

    }
}
